import { QuickUseViewState } from '../store/schema/QuickUseViewState';

export default function createQuickUseViewState(): QuickUseViewState {
    return <QuickUseViewState>{
        isQuickUseVisible: false,
    };
}
